import { combineReducers } from '@reduxjs/toolkit'
import todoReducer from 'components/features/example/todos/todosSlice'
import goalReducer from 'components/features/example/goals/goalsSlice'
import authenticationReducer from 'reducers/authentication/authenticationSlice'
import userprofileReducer from 'reducers/userprofile/userprofileSlice'
import forgotPasswordReducer from 'reducers/forgotPassword/forgotpasswordSlice'
import activeCaseReducer from 'reducers/activecase/activecaseSlice'
import documentProcessingReducer from 'reducers/document/documentProcessingSlice'
import credentialsReducer from 'reducers/authentication/credentialsSlice'
import coursesReducer from 'reducers/activecourse/activecourseSlice'
import sectionReducer from 'reducers/activesection/activesectionSlice'

const rootReducer = combineReducers({
  todos: todoReducer,
  goals: goalReducer,
  authentication: authenticationReducer,
  userprofile: userprofileReducer,
  forgotPasswordData: forgotPasswordReducer,
  activeCase: activeCaseReducer,
  documentProcessing: documentProcessingReducer,
  credentials: credentialsReducer,
  activeCourse: coursesReducer,
  activeSection: sectionReducer
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
